import React from 'react';
const IconArrowDropdown = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.199 19.6172C11.5989 20.1522 12.4009 20.1522 12.8008 19.6172L15.8048 15.5987C16.2977 14.9393 15.8272 14 15.0038 14H8.99595C8.17264 14 7.70206 14.9393 8.19501 15.5987L11.199 19.6172Z" fill="#666666"/>
<path d="M11.199 4.40126C11.5989 3.86625 12.4009 3.86625 12.8008 4.40126L15.8048 8.41974C16.2977 9.07917 15.8272 10.0185 15.0038 10.0185H8.99595C8.17264 10.0185 7.70206 9.07917 8.19501 8.41974L11.199 4.40126Z" fill="#666666"/>
</svg>
);
};
export default IconArrowDropdown;